import { combineReducers } from "redux"

// Front
import Layout from "./layout/reducer"

// Authentication
import Login from "./auth/login/reducer"
import Profile from "./auth/profile/reducer"

//Lamp
import lamp from "./lamp/reducer"

const rootReducer = combineReducers({
  // public
  Layout,
  Login,
  Profile,
  lamp,
})

export default rootReducer
